var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlignRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "presentation",
    focusable: "false",
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "ui-icon__outline",
    d: "M1 21c-1,1 -1,3 -1,4 0,1 0,3 1,4 1,1 3,1 4,1l150 0c1,0 3,0 4,-1 1,-1 1,-3 1,-4 0,-1 0,-3 -1,-4 -1,-1 -3,-1 -4,-1l-150 0c-1,0 -3,0 -4,1zm44 120c-1,1 -2,3 -2,4 0,1 1,3 2,4 1,1 2,1 3,1l107 0c1,0 3,0 4,-1 1,-1 1,-3 1,-4 0,-1 0,-3 -1,-4 -1,-1 -3,-1 -4,-1l-107 0c-1,0 -2,0 -3,1zm-44 -40c-1,1 -1,3 -1,4 0,1 0,3 1,4 1,1 3,1 4,1l150 0c1,0 3,0 4,-1 1,-1 1,-3 1,-4 0,-1 0,-3 -1,-4 -1,-1 -3,-1 -4,-1l-150 0c-1,0 -3,0 -4,1zm44 -40c-1,1 -2,3 -2,4 0,1 1,3 2,4 1,1 2,1 3,1l107 0c1,0 3,0 4,-1 1,-1 1,-3 1,-4 0,-1 0,-3 -1,-4 -1,-1 -3,-1 -4,-1l-107 0c-1,0 -2,0 -3,1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ui-icon__filled",
    d: "M0 20c0,-6 4,-10 10,-10l140 0c6,0 10,4 10,10 0,6 -4,10 -10,10l-140 0c-6,0 -10,-4 -10,-10zm43 40c0,-6 5,-10 10,-10l97 0c6,0 10,4 10,10 0,6 -4,10 -10,10l-97 0c-5,0 -10,-4 -10,-10zm-43 40c0,-6 4,-10 10,-10l140 0c6,0 10,4 10,10 0,6 -4,10 -10,10l-140 0c-6,0 -10,-4 -10,-10zm43 40c0,-6 5,-10 10,-10l97 0c6,0 10,4 10,10 0,6 -4,10 -10,10l-97 0c-5,0 -10,-4 -10,-10z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignRight);
export default __webpack_public_path__ + "static/media/align_right.23b577ab.svg";
export { ForwardRef as ReactComponent };